import * as CAction from './filter.actionTypes';
import { Dispatch } from 'react';
import BoardService from '../services/board.service';

const boardSevice = new BoardService();

const normalizeAssigneeForApi = (assignee: any): string => {
    if (Array.isArray(assignee)) {
        return assignee.filter(Boolean).map((id) => String(id)).join(',');
    }
    if (assignee === null || typeof assignee === 'undefined') {
        return '';
    }
    return String(assignee);
};

const normalizeArrayForApi = (value: any): string[] => (
    Array.isArray(value) ? value : []
);

const serializeFiltersForApi = (allFilters: Record<string, any>, wsId: string | null) => ({
    wsId,
    subaction: allFilters.subaction || 0,
    highlighted_my_items: allFilters.highlighted_my_items || 0,
    done_items: allFilters.done_items || '',
    hide_done_items: allFilters.hide_done_items || 0,
    showIssueTypeIcon: allFilters.showIssueTypeIcon || 0,
    highlightIssuesByType: allFilters.highlightIssuesByType || 0,
    assignee: normalizeAssigneeForApi(allFilters.assignee),
    status: normalizeArrayForApi(allFilters.status),
    rating: normalizeArrayForApi(allFilters.rating),
    priority: normalizeArrayForApi(allFilters.priority),
    issueTypes: normalizeArrayForApi(allFilters.issueTypes),
    tags: normalizeArrayForApi(allFilters.tags),
    tags_operator: allFilters.tags_operator || 'includes',
});

export const changeFilterAttribute = (name: string, value: any, isChecked?: boolean) => async (dispatch: Dispatch<CAction.FilterActionTypes>, getState: any) => {
    try {
        dispatch({
            type: CAction.FILTER_ATTR_CHANGE,
            name,
            value,
            isChecked
        });
        const updatedState = getState();
        const allFilters = updatedState.boardFilters;
        const wsId = updatedState.boardDetails?.tagId || null;

        boardSevice.saveBoardFilters(serializeFiltersForApi(allFilters, wsId));
    }
    catch(e) {

    }
}

export const applyBoardFilters = (payload: Record<string, any>) => async (dispatch: Dispatch<CAction.FilterActionTypes>, getState: any) => {
    try {
        dispatch({
            type: CAction.FILTER_ATTR_BULK_APPLY,
            payload,
        });
        const updatedState = getState();
        const allFilters = updatedState.boardFilters;
        const wsId = updatedState.boardDetails?.tagId || null;
        boardSevice.saveBoardFilters(serializeFiltersForApi(allFilters, wsId));
    } catch (e) {
    }
};
